import { DateRangeType } from "@shared-features/enums/shared-enums.enum";

export class LocalStorageDashboardStatus {
    generalTime: DateRangeType;
    orderStatusTime: DateRangeType;
    businessUnitStatusTime: DateRangeType;
    businessUnitStatusOrganizationTime: DateRangeType;
    businessUnitStatusOrganizationCustomerId: string;
    businessUnitStatusOrganizationCustomTimeFrom: string;
    businessUnitStatusOrganizationCustomTimeTo: string;
    orderFulfillmentTime: string;
    orderFulfillmentCustomers: number;
    topDriversTime: DateRangeType;
    topDriversCustomer: number[];
    totalJoinedTime: DateRangeType;
    totalContractsTime: DateRangeType;
    totalDriversTime: DateRangeType;
    totalTrucksTime: DateRangeType;

}
